import axiosClient from '../configs/axios';


class InternalMovementService {
    // Get list 
    async getInternalMovementList(params) {
        try {
            const response = await axiosClient.get(
                `/ime/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addInternalMovement(data) {
        try {
            const response = await axiosClient.post('/ime/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteInternalMovement(data) {
        try {
            const response = await axiosClient.put(`/ime/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new InternalMovementService(); 